module.exports = new __parcel__URL__("let-it-be.2948ae19.jpg").toString();